import { render, staticRenderFns } from "./FileModel.vue?vue&type=template&id=6bb9d85a&scoped=true"
import script from "./FileModel.vue?vue&type=script&lang=js"
export * from "./FileModel.vue?vue&type=script&lang=js"
import style0 from "./FileModel.vue?vue&type=style&index=0&id=6bb9d85a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb9d85a",
  null
  
)

export default component.exports